// Data-Processing summary — links the operator to a downloadable DPA.
import LegalPageLayout from './LegalPageLayout';

const H = ({ children }) => (
  <h2 className="text-white text-xl font-semibold mt-8 mb-2">{children}</h2>
);
const P = ({ children }) => (
  <p className="text-slate-300 text-[15px]">{children}</p>
);

export default function DataProcessingPage({ onBack, companyName = 'AeroGuard SMS' }) {
  return (
    <LegalPageLayout title="Data Processing" effective="February 2026" onBack={onBack}>
      <P>
        This page summarises the data-processing arrangement between the
        operator ("Controller") and {companyName} ("Processor") during the
        pilot phase. The full Data Processing Agreement (DPA), including
        Standard Contractual Clauses for cross-border transfers, is
        available on request through the in-app <em>Support</em> button.
      </P>

      <H>Nature and purpose of processing</H>
      <P>
        Storage, retrieval, analytics, notifications and PDF generation of
        aviation safety records supplied by the Controller, for the purpose
        of operating a Safety Management System compliant with ICAO Annex 19.
      </P>

      <H>Categories of data subjects</H>
      <ul className="list-disc pl-6 space-y-1 text-slate-300 text-[15px]">
        <li>Flight crew, cabin crew, ground personnel and maintenance staff of the operator.</li>
        <li>Passengers whose personal data is voluntarily included in an incident report.</li>
        <li>Third-party contacts named in audit findings and corrective actions.</li>
      </ul>

      <H>Categories of personal data</H>
      <ul className="list-disc pl-6 space-y-1 text-slate-300 text-[15px]">
        <li>Identifiers: full name, employee id, email, phone.</li>
        <li>Professional data: role, department, business-unit, licences and expiry dates.</li>
        <li>Free-text safety narratives which may incidentally contain personal data.</li>
        <li>Technical data: IP address, user agent, session tokens (used for security and audit).</li>
      </ul>

      <H>Sub-processors</H>
      <P>
        A current list of sub-processors, their locations, and the categories
        of personal data they process is maintained in the DPA appendix. Any
        change to sub-processors will be notified to the Controller by
        email at least fourteen (14) days in advance.
      </P>

      <H>International transfers</H>
      <P>
        Personal data may be transferred to Ireland (Resend), the United
        States (OpenAI) and to the sub-processor MongoDB Atlas region
        configured for the tenant. Transfers rely on Standard Contractual
        Clauses and/or PDPL-approved transfer mechanisms.
      </P>

      <H>Duration and deletion</H>
      <P>
        Processing continues for the duration of the pilot. On termination
        the Controller may request a full data export within thirty (30)
        days, after which all Customer Data (including backups) is deleted.
      </P>

      <H>Security measures</H>
      <ul className="list-disc pl-6 space-y-1 text-slate-300 text-[15px]">
        <li>TLS 1.2+ in transit; database encryption at rest.</li>
        <li>Per-tenant scoped queries + business-unit isolation.</li>
        <li>JWT authentication with brute-force protection and audit logging.</li>
        <li>Regular software updates and dependency scanning.</li>
      </ul>

      <H>Requesting the DPA</H>
      <P>
        To countersign the Data Processing Agreement, open the in-app
        Support widget (bottom-right on every page) with category "Question"
        and subject "Request DPA". Your account owner will be notified.
      </P>
    </LegalPageLayout>
  );
}
